import React from 'react'
import { Trackable } from '../tracking'
import AloButton from '../AloButton'
import PropTypes from 'prop-types'

const TrackableButton = ({
  onClick,
  url,
  name,
  buildToTrackParams,
  ...props
}) => {
  return (
    <Trackable url={url} name={name}>
      {({ currTracked, updateToTrack }) => {
        return (
          <AloButton
            {...props}
            onClick={() => {
              onClick()
              const params = buildToTrackParams(currTracked)
              updateToTrack(params)
            }}
          />
        )
      }}
    </Trackable>
  )
}

TrackableButton.propTypes = {
  onClick: PropTypes.func,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  buildToTrackParams: PropTypes.func.isRequired
}

export default TrackableButton
